import { render, staticRenderFns } from "./menu-more.vue?vue&type=template&id=6d6ff628&scoped=true&"
import script from "./menu-more.vue?vue&type=script&lang=js&"
export * from "./menu-more.vue?vue&type=script&lang=js&"
import style0 from "./menu-more.vue?vue&type=style&index=0&id=6d6ff628&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6ff628",
  null
  
)

export default component.exports